require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('../generic.view.ts');
var Handlebars = require('handlebars');

var Template = require('text-loader!../../templates/tickets/tickets.template.htm');
var Table = require('text-loader!../../templates/tickets/tickets_table.template.htm');

var Collection = require('../../models/tickets.paginated.collection.ts');
require('dhtmlxMessage');

var Pagination = require('../../views/pagination.view.ts');
var HandlebarsHelpers = require('../../../libs/handlebars/handlebars-helpers.ts');

require('../../../libs/bootstrap/js/bootstrap-table.js');
var i18n = require("l10n");
var popup = require('popup');
require('jqueryUI');
require('jqueryUIDatePickerEnglish');
require('jqueryUIDatePickerGreek');

var TicketPaymentRowView = require("./ticketRow.view.ts");
// var AppointmentRowView = require("./appointmentRow.view.ts");
var QueueStateView = require("./queueState.view.ts");

var SockJS = require('sockjs-client');
var Stomp = require('stompjs');

var TheView = GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	progressTemplate: Handlebars.compile("{{> progressPartial}}"),
	table: Handlebars.compile(Table),
	// appointmentsCollection: null,
	model: null,
	isFirstDisplay: true,
	isDownloadAccordionOpen: false,
	lastSearchedText: "",
	userData: null,
	queueTicketStompSubscriptions: null,
	queueAppointmentsStompSubscription: null,
	queueStateStompSubscription: null,
    downloadFrom: $.datepicker.formatDate('yy-mm-dd', new Date()),
	downloadTo: $.datepicker.formatDate('yy-mm-dd', new Date()),
    minDateHistory: null,
	initialize: function (options) {
		var self = this;

        this.userData = options ? options.userData : null;

		this.orgsVenuesQueuesCollection = new Collection();
		this.orgsVenuesQueuesCollection.state.pageSize = 999;
		this.orgsVenuesQueuesCollection.on( 'sync', this.successData, this );
		this.orgsVenuesQueuesCollection.on( 'error', this.errorData, this );

		this.orgsVenuesQueuesCollection.url = '/rest/api/admin/OrgsVenuesQueues';
		this.orgsVenuesQueuesCollection.getFirstPage();

		this.setListener(); // stomp listener
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;
		this.$el.html(this.template());
        // this.initializeDatePicker();
		return this;
	},
	events: {
	    "click .queueAccordion": "loadTicketsAndAppointmentsForQueue",
        "click .downloadExcelAccordionContainer": "initializeDatePicker",
	    "click .downloadExcelButton": "downloadExcel"
	},
    initializeDatePicker: function(e)
    {
        var self = this;

	    const $elem = $(e.currentTarget);
        var queueId = $elem.data("queue");

        $.datepicker.setDefaults( $.datepicker.regional[ i18n.lng() ] );
    
        var datepickerOptions = {
            //"yearRange": (yearFrom +":"+ yearTo),
            "dateFormat": "yy-mm-dd",
            maxDate: '+0d',
            minDate: self.minDateHistory
        };
        var currentStartingInput = $("#downloadDataStartingDate-" + queueId);
        var currentEndingInput = $("#downloadDataEndingDate-" + queueId);

        var starting = currentStartingInput;
        starting.datepicker(datepickerOptions);
        starting.val(this.downloadFrom);

        var ending = currentEndingInput;
        ending.datepicker(datepickerOptions);
        ending.val(this.downloadTo);
    },
	unsubscribeStomp: function(self) {
	    if(self.queueTicketStompSubscription) {
            self.queueTicketStompSubscription.unsubscribe();
            self.queueTicketStompSubscription = null;
	    }

        // if(self.queueAppointmentsStompSubscription) {
        //     self.queueAppointmentsStompSubscription.unsubscribe();
        //     self.queueAppointmentsStompSubscription = null;
	    // }

        if(self.queueStateStompSubscription) {
            self.queueStateStompSubscription.unsubscribe();
            self.queueStateStompSubscription = null;
	    }
	},
	subscribeToStomp: function(self) {
	    if(self.queueTicketStompSubscription == null) {
            self.queueTicketStompSubscription = self.client.subscribe('/live/admin/tickets/queue/', function (message){
                var responseObject = JSON.parse( message.body );

                if(responseObject.queueId) {
                    var elem = $("#queue-" + responseObject.queueId);
                    self.loadTicketsPayments(elem, responseObject);
                }
            });
	    }

        // if(self.queueAppointmentsStompSubscription == null) {
        //     self.queueAppointmentsStompSubscription = self.client.subscribe('/live/admin/appointments/queue/', function (message){
        //         var responseObject = JSON.parse( message.body );

        //         if(responseObject.queueId) {
        //             var elem = $("#queue-" + responseObject.queueId);
        //             self.loadAppointments(elem);
        //         }
        //     });
        // }

        if(self.queueStateStompSubscription == null) {
            self.queueStateStompSubscription = this.client.subscribe('/live/admin/queueState/', function (message){
                var responseObject = JSON.parse( message.body );

                if(responseObject && responseObject.id) {
                    var $elem = $("#queue-" + responseObject.id);

                    const params = {
                        "wsocket": self.wsocket,
                        "client": self.client,
                        "model": {
                            "queueState": responseObject.queueState,
                            "id": responseObject.id
                        }
                    };

                    const $statusContainer = $elem.parent().find(".queueState");

                    var queueStateView = new QueueStateView( params );
                    $statusContainer.html( queueStateView.render().el );

                    $statusContainer.notify(i18n.t('tickets.queueStateChanged'), { position:"bottom center", className: "info" });
                }
            });
        }
    },
    setListener: function()
    {
        var self = this;

        this.wsocket = new SockJS('rest/live');
        this.client = Stomp.over(this.wsocket);

        var headers = {
            //origin: 'https://www.qedis-metro.com', toDo: enable it
        };

        this.client.connect(headers,
            function(frame) {
                //self.subscribeToStomp(self);
            },
            function(onCloseMessage) {
                if(onCloseMessage.indexOf('Whoops! Lost connection to') > -1) {
                    //
                    console.log("connection closed");
                }
            }
        );
    },
	successData: function()
	{
		var self = this;
		self.hideActionProgressBar();

		if(this.isFirstDisplay)
		{
			this.isFirstDisplay = false;
			this.render();
            if(this.orgsVenuesQueuesCollection.models.length == 0)
                $('#search-container').hide();
		}

		$('#table-container').html(this.table({ "orgs" : this.orgsVenuesQueuesCollection.models, pageInfo : this.orgsVenuesQueuesCollection.info()}));


		if(this.orgsVenuesQueuesCollection.models.length > 0)
		{
			$('#table-container').show();
			$('#empty').hide();

            //self.initializeTrs(this.showHideActionButton, "#dataTables");
		}
		else
		{
			$('#table-container').hide();
			$('#empty').show();
		}

		this.$el.find(".accordion").accordion({
		    collapsible: true,
		    active: false
		});
	},
	errorData: function(orgsVenuesQueuesCollection, xhr, options)
	{
 		this.onErrorHandler(orgsVenuesQueuesCollection, xhr, options);
	},
	renderTickets: function($ticketsContainer, data, stompData) {
	    var self = this;

	    $ticketsContainer.empty();

        $.each(data, function(i, item) {

            var params = {
                "wsocket": self.wsocket,
                "client": self.client,
                "model": item
            };

            var rowView = new TicketPaymentRowView( params );
            $ticketsContainer.append( rowView.render().el );

            var $popup = $("#ticketsPaymentsAppointmentsPopup").find(".tpaPopup");
            var id = parseInt( $($popup[0]).data("id") );
            var isPayment = $($popup[0]).data("type") == "payment";
            var isTicket = $($popup[0]).data("type") == "ticket";

            var isSameId = isTicket
                ? id == item.id
                : isPayment
                    ? id == item.paymentId
                    : false;

            // if it has, an opened popup, reload it
            if( !isNaN(id) && isSameId && $popup.parent().css("display") == "block" ) {
                // check if this user, has done the action that closes automatically the popup. If so, then do NOT close the popup, it will be closed automatically.
                var hasThisUserDoneThisAction = stompData && stompData.userId == self.userData.id;

                if(!hasThisUserDoneThisAction) {
                    rowView.closePopup();
                    $(rowView.$el.find("td")[0]).trigger("click");
                }
            }
        });
	},
	// renderAppointments: function($appointmentsContainer, data) {
    //     var self = this;

    //     $appointmentsContainer.empty();

    //     $.each(data, function(i, item) {

    //         var params = {
    //             "wsocket": self.wsocket,
    //             "client": self.client,
    //             "model": item
    //         };

    //         var rowView = new AppointmentRowView( params );

    //         $appointmentsContainer.append( rowView.render().el );
    //     });

    //     this.bindTicketStatusEvents();
    // },
	loadTicketsAndAppointmentsForQueue: function(e) {
	    const self = this;
	    const $elem = $(e.currentTarget);

        if(!$elem.hasClass("ui-accordion-header-active")) { // closing the accordion
            this.unsubscribeStomp(this);

            $(window).trigger("tickets:closed");
            return;
        }

        this.loadTicketsPayments($elem, null);
        // this.loadAppointments($elem);
        this.loadQueueStatus($elem);

        this.subscribeToStomp(this);
	},
	loadTicketsPayments: function($elem, stompData) {
        var self = this;

        const $ticketsContainer = $($elem.parent().find(".ticketsContainer")[0]);
	    var queueId = $elem.data("queue");

        $ticketsContainer.empty();

        var tr = $("<tr/>");
        tr.css("display", "block");
        tr.html(self.progressTemplate());
        $ticketsContainer.append(tr);

	    $.ajaxDefaultQ({
        	url: this.orgsVenuesQueuesCollection.url + "/" + queueId,
        	type: 'GET',
        }).done(function(response, status, xhr){
        	if(status == "success")
        	{
        	    if(response.data && response.data.length && response.data.length > 0) {

        	        self.renderTickets($ticketsContainer, response.data, stompData);
        		}
        		else {
        		    $ticketsContainer.text(i18n.t('tickets.noTicketsAndPayments'));
                }

                if(response.meta && response.meta.minDateHistory != null) {
                    self.minDateHistory = new Date(response.meta.minDateHistory);
                }
        	}
        	else {
        	    console.error("Error while getting tickets for Queue ("+ queueId +")");
        	}
        })
        .fail(function(response) {
            console.error("Error while getting tickets for Queue ("+ queueId +")", response);
        });
	},
	// loadAppointments: function($elem) {
	//     var self = this;

	//     const $appointmentsContainer = $($elem.parent().find(".appointmentsContainer")[0]);
    //     var queueId = $elem.data("queue");

    //     $appointmentsContainer.empty();

    //     var tr = $("<tr/>");
    //     tr.css("display", "block");
    //     tr.html(self.progressTemplate());
    //     $appointmentsContainer.append(tr);

    //     $.ajaxDefaultQ({
    //         url:  "/rest/api/admin/appointments/" + queueId,
    //         type: 'GET',
    //     }).done(function(response, status, xhr){
    //         if(status == "success")
    //         {
    //             if(response.data && response.data.length && response.data.length > 0) {
    //                 self.renderAppointments($appointmentsContainer, response.data);
    //             }
    //             else {
    //                 $appointmentsContainer.text(i18n.t('tickets.noAppointments'));
    //             }
    //         }
    //         else {
    //             console.error("Error while getting appointments for Queue ("+ queueId +")");
    //         }
    //     })
    //     .fail(function(response) {
    //         console.error("Error while getting appointments for Queue ("+ queueId +")", response);
    //     });
	// },
	loadQueueStatus: function($elem) {
	    var self = this;

	    const $statusContainer = $elem.parent().find(".queueState");
        var queueId = $elem.data("queue");

	    $.ajaxDefaultQ({
            url:  "/rest/api/admin/queueStatus/" + queueId,
            type: 'GET',
        }).done(function(response, status, xhr){
            if(status == "success") {
                if(response.data) {
                    self.queueState = response.data;

                    const params = {
                        "wsocket": self.wsocket,
                        "client": self.client,
                        "model": {
                            "queueState": self.queueState,
                            "id": queueId
                        }
                    };

                    var queueStateView = new QueueStateView( params );
                    $statusContainer.html( queueStateView.render().el );
                }
                else {
                    $statusContainer.text(i18n.t('user.error'));
                }
            }
            else {
                console.error("Error while getting queue status for Queue ("+ queueId +")");
            }
        })
        .fail(function(response) {
            console.error("Error while getting appointments for Queue ("+ queueId +")", response);
        });
	},
	downloadExcel: function(e) {
	    var self = this;
        self.showActionProgressBar();
        var queueId = $(e.currentTarget).data("queue");

        var inputFrom = $("#downloadDataStartingDate-" + queueId);
        var inputTo = $("#downloadDataEndingDate-" + queueId);

        var dateFrom = new Date(inputFrom.val());
        var dateTo = new Date(inputTo.val());


        var validDates = true;

        if(dateFrom instanceof Date && !isNaN(dateFrom))
            inputFrom.removeClass("error");
        else
        {
            validDates = false;
            inputFrom.addClass("error");
        }

        if(dateTo instanceof Date && !isNaN(dateTo))
            inputTo.removeClass("error");
        else
        {
            validDates = false;
            inputTo.addClass("error");
        }

        if(!validDates)
        {
            $.notify(i18n.t("analytics.invalid_date"), { position:"top center", className: "error" });
            return;
        }

        if(dateFrom > dateTo)
        {
            $.notify(i18n.t("analytics.less_than"), { position:"top center", className: "error" });
            inputTo.addClass("error");
            return;
        }

        this.downloadFrom = inputFrom.val();
        this.downloadTo = inputTo.val();

	    $.ajaxDefaultQ({
            url:  "/rest/api/admin/extract-excel/" + queueId + (this.downloadFrom && this.downloadTo ? '?startDate=' + this.downloadFrom + '&endDate=' + this.downloadTo : ''),
            type: 'GET',
            xhrFields: {
                responseType: 'blob'
            },
            // contentType: "text/plain"
        }).done(function(response, status, xhr){
            if(status == "success") {
                if(response) {
                    const url = window.URL.createObjectURL(response);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'Tickets_history_Queue_' + queueId + '_' + inputFrom.val() + '_' + inputTo.val() + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    self.hideActionProgressBar();
                }
                else {
                    
                }
            }
            else {
                console.error("Error while getting file for Queue ("+ queueId +")");
            }
        })
        .fail(function(response) {
            console.error("Error while getting file for Queue ("+ queueId +")", response);
        });
    },
    s2ab: function(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    },
	// sample for URL and call
	bindTicketStatusEvents: function() {

        $(".ticketRow").find(".ticketPriority").off('change').on('change', function(evt) {

            var $elem = $(this);
            var status = $elem.val();
            var ticketId = null;
            var queueId = null;

            try {
                ticketId = parseInt($elem.parent().parent().attr("id").split("-")[1]);
                queueId = parseInt($elem.parent().parent().parent().attr("id").split("-")[1]);
            }
            catch(exc) {

            }

            if(status < 1 || status > 3 || ticketId == null || isNaN(ticketId) || ticketId < 1) {
                $elem.notify(i18n.t('tickets.wrongValueSelected'), { position:"top center", className: "error" });
                return;
            }

            $.ajaxDefaultQ({
                url: "rest/api/admin/ticket/priority?ticketId=" + ticketId + "&status="+ status + "&queueId=" + queueId,
                type: "POST",
                contentType: "application/json",
                data: {}
            }).done(function(response, status, xhr){

                if(response && response.error == null) {

                    var text = "";
                    var className = "";

                    if(response.data == true || response.data && response.data.value == true) {
                        text = i18n.t("counter.refreshed");
                        className = "success";
                    }
                    else if(response.data == false || response.data && response.data.value == false) {
                        text = i18n.t("server.errorOccurred");
                        className = "error";

                        // revert selection
                        $elem.val($elem.data("last-value"));
                    }
                    else {
                        text = i18n.t("server.errorOccurred");
                        className = "error";

                        // revert selection
                        $elem.val($elem.data("last-value"));
                    }

                    $elem.notify(text,
                    {
                        position: "left center",
                        className: className,
                        autoHide: true
                    });

                }
                else {
                    $elem.notify(i18n.t("server.errorOccurred"),
                    {
                        position:"left center",
                        className: "error",
                        autoHide: true
                    });

                    // revert selection
                    $elem.val($elem.data("last-value"));
                }

            })
            .fail(function(response) {
                $elem.notify(i18n.t("server.errorOccurred"),
                {
                    position: "left center",
                    className: "error",
                    autoHide: true
                });

            });
        });


	}
});

module.exports = TheView;